// src/utils/api.js
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// ✅ Helper function to get Authorization header
const getAuthHeader = () => {
    const token = localStorage.getItem('piwatch_token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

/**
 * Fetch all sensor data from the backend.
 * Sorts data by timestamp ascending.
 * Now includes Authorization header.
 */
export const fetchAllSensorData = async () => {
    try {
        const headers = {
            ...getAuthHeader(), // ✅ Add JWT token if available
            'Content-Type': 'application/json' // Keep content type if needed
        };
        const response = await fetch(`${API_BASE_URL}/sensors/all`, {
             headers: headers, // ✅ Pass headers
             cache: 'no-store'
        });

        if (!response.ok) {
            // Handle specific auth errors
            if (response.status === 401) {
                 console.error("Unauthorized: Token might be invalid or expired.");
                 // Optionally trigger logout or token refresh logic here
                 localStorage.removeItem('piwatch_token');
                 window.location.reload(); // Simple way to force login
            } else {
                console.error("API error status:", response.status);
            }
            return [];
        }

        let data = await response.json();
        if (!Array.isArray(data)) {
            console.warn("API did not return an array, checking common wrappers:", data);
            data = data.records || data.data || [];
            if (!Array.isArray(data)) return [];
        }

        const cleanedData = data
            .map(item => ({
                ...item,
                timestamp: Number(item.timestamp) || 0,
            }))
            .filter(item => item.timestamp > 0)
            .sort((a, b) => a.timestamp - b.timestamp);

        return cleanedData;
    } catch (error) {
        console.error("❌ Error fetching sensor data:", error);
        return [];
    }
};

// Add other non-device related API functions here and ensure they also use getAuthHeader() if protected